import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-dynamic',
  templateUrl: './reports-dynamic.component.html',
  styleUrls: ['./reports-dynamic.component.scss']
})
export class ReportsDynamicComponent {
  tab = 0;
}
